import React, { useState } from 'react';
import Placeholder from '../Placholder';
import { CommonModal, PrimaryButton, Select } from '../../Common';
import Routes from '../../../routes';
import { Box, Grid } from '@mui/material';
import '../../Common/Filters/Filters.css';
import { fetchReportExport } from '../utils';

const NYDECExport = () => {
    const [loadingExport, setLoadingExport] = useState(false);
    const [reportModal, setReportModal] = useState(false);
    const [reportName, setReportName] = useState('MultiFacility');

    const exportOptions = [
        { id: 'MultiFacility', label: 'Multi-Facility Export' },
        { id: 'MultiFacilityEquipment', label: 'Multi-Facility Equipment Export' }
    ];

    const exportReport = async () => {
        setReportModal(false);
        setLoadingExport(true);

        await fetchReportExport({
            url: Routes.PowerBI.NYDECExport(),
            body: {
                Filters: [
                    { Property: 'reportName', Value: reportName }
                ]
            }
        });

        setLoadingExport(false);
    };

    return (
        <>
            <Placeholder
                message={'Customize and export your report by clicking the button below.'}
                subMessage={''}
            >
                <Grid item xs={12} md={3} sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '2rem'
                }}>
                    <PrimaryButton
                        buttonText="GENERATE REPORT (.xlsx)"
                        onClick={() => {
                            setReportModal(true);
                        }}
                        disabled={loadingExport}
                    />
                </Grid>
            </Placeholder>

            <CommonModal
                open={reportModal}
                close={() => setReportModal(false)}
                header="NY DEC Registration Exports"
            >
                <Grid container spacing={3} align='center'>
                    <Grid item xs={8} lg={8} sx={{ marginLeft: 12, minWidth: '400px' }} align='center'>
                        <Select
                            variant={"standard"}
                            options={exportOptions}
                            label="Select Export Type"
                            onChange={e => {
                                setReportName(e.target.value);
                            }}
                            value={reportName}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12} lg={12} align='center'>
                        <Box mb={2} sx={{ width: '65%' }}>
                            <PrimaryButton
                                fullWidth
                                size='large'
                                variant='contained'
                                onClick={exportReport}
                                buttonText={"GENERATE REPORT (.xlsx)"}
                            >
                            </PrimaryButton>
                        </Box>
                    </Grid>
                </Grid>
            </CommonModal>
        </>
    );
};

export default NYDECExport;
